export default __webpack_public_path__ + "static/media/point.e5e42130.svg";